import React from 'react';
import { motion } from 'framer-motion';
import { Flame, Truck } from 'lucide-react';
const EBOOK_IMG = 'https://cdn.magicpatterns.com/uploads/2XS4iRnXLktvBQ5bjZFkth/heylloyd-image-1771396819959.png';
export function BenefitsSection() {
  return <section className="py-20 px-4 md:px-8 bg-white" data-id="element-13">
      <div className="max-w-6xl mx-auto" data-id="element-14">
        <div className="text-center mb-16" data-id="element-15">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brown-deep" data-id="element-16">
            Todo lo que incluye tu Kit
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-17">
          {/* Card 1: Faja */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0,
          duration: 0.5
        }} className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-gold hover:shadow-xl transition-shadow group" data-id="element-18">
            <div className="w-14 h-14 rounded-full bg-rose/30 flex items-center justify-center mb-6 text-coral group-hover:scale-110 transition-transform duration-300" data-id="element-19">
              <Flame className="w-7 h-7" data-id="element-20" />
            </div>
            <h3 className="text-xl font-bold text-brown-deep mb-4" data-id="element-21">
              Faja Térmica Reforzada
            </h3>
            <p className="text-brown-medium leading-relaxed" data-id="element-22">
              No se enrolla, no irrita y mantiene el calor donde más lo
              necesitás. Diseño ergonómico que se adapta a tu cuerpo.
            </p>
          </motion.div>

          {/* Card 2: Ebook con mockup */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2,
          duration: 0.5
        }} className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-gold hover:shadow-xl transition-shadow group" data-id="element-23">
            <div className="w-full aspect-[16/10] rounded-xl overflow-hidden mb-6 bg-cream" data-id="element-24">
              <img src={EBOOK_IMG} alt="Ebook Protocolo Vientre Plano 21D" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-25" />
            </div>
            <h3 className="text-xl font-bold text-brown-deep mb-4" data-id="element-26">
              Ebook Método 21D
            </h3>
            <p className="text-brown-medium leading-relaxed" data-id="element-27">
              El paso a paso para que cada minuto que uses la faja cuente el
              doble. Incluye guía de masajes linfáticos.
            </p>
          </motion.div>

          {/* Card 3: Envío */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4,
          duration: 0.5
        }} className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-gold hover:shadow-xl transition-shadow group" data-id="element-28">
            <div className="w-14 h-14 rounded-full bg-rose/30 flex items-center justify-center mb-6 text-coral group-hover:scale-110 transition-transform duration-300" data-id="element-29">
              <Truck className="w-7 h-7" data-id="element-30" />
            </div>
            <h3 className="text-xl font-bold text-brown-deep mb-4" data-id="element-31">
              Envío a Toda Argentina
            </h3>
            <p className="text-brown-medium leading-relaxed" data-id="element-32">
              Directo a tu puerta, con stock real y seguimiento de envío.
              Llegamos a cada rincón del país.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}